import styled from 'styled-components';
import { Colors, MagicBox } from '@brg/ui';
import { LayoutConst } from 'core/modules';

export const TeamPageViewportLayout = styled(MagicBox)`
    background: ${Colors.geo};
    width: 100%;
    flex-direction: column;
`;

export const TeamImg = styled.div<{ src: string }>`
    width: 100%;
    height: 270px;
    background: darkgray url('${(p) => p.src}') center center;
    background-size: cover;
    @media (max-width: ${LayoutConst.screen.l_12}px) {
        height: 217px;
    }
`;
import styled from 'styled-components';
import { Colors, MagicBox } from '@brg/ui';
import { LayoutConst } from 'core/modules';

export const TeamPageViewportLayout = styled(MagicBox)`
    background: ${Colors.geo};
    width: 100%;
    flex-direction: column;
`;

export const TeamImg = styled.div<{ src: string }>`
    width: 100%;
    height: 270px;
    background: darkgray url('${(p) => p.src}') center center;
    background-size: cover;
    @media (max-width: ${LayoutConst.screen.l_12}px) {
        height: 217px;
    }
`;
